import React, { useContext } from 'react'
import { ButtonStyled } from './Button.styles'

import { StoreContext } from '@/components/App'

interface ButtonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any
  children: React.ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  className?: any
  isDisabled?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (props: any) => any
}

export const Button = ({ children, className, isDisabled, onClick }: ButtonProps) => {
  const store = useContext(StoreContext)
  const { theme } = store.AppState

  function handleOnClick(e) {
    onClick && onClick(e)
  }

  return (
    <ButtonStyled
      {...theme.button}
      disabled={isDisabled}
      onClick={(e) => handleOnClick(e)}
      className={className ? className : ''}
    >
      {children}
    </ButtonStyled>
  )
}
